class TokenStorage {
  private static instance: TokenStorage;
  private _token: string | null = null;

  public static getInstance(): TokenStorage {
    if (!TokenStorage.instance) {
      TokenStorage.instance = new TokenStorage();
    }
    return TokenStorage.instance;
  }

  public getToken(): string | null {
    return this._token;
  }

  public setToken(newToken: string | null | undefined): void {
    this._token = newToken ?? null;
  }
}

const tokenStorage = TokenStorage.getInstance();

export const getToken = (): string | null => {
  return tokenStorage.getToken();
};

export const setToken = (token: string | null | undefined): void => {
  tokenStorage.setToken(token ?? null);
};
